const Layout = ({children}) => {
  return (
    <main className="max-w-[1400px] w-full mx-auto px-2 md:px-10">
        {children}
    </main>
  )
}

export default Layout